export default {"src":"https://frontends.udemycdn.com/frontends-marketplace-experience/_next/static/media/development.56ecd3e7.svg","height":24,"width":24};